export default {
	bind (el) {
		el.classList.add('wc-messagebox__btn--then');
	}
}


// WEBPACK FOOTER //
// ./src/wc-messagebox/directives/wc-then.js